import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, NgModule, Output } from '@angular/core';
import { NgbAlertModule } from '@ng-bootstrap/ng-bootstrap';
import kebabCase from 'lodash-es/kebabCase';

export enum BannerType {
  InfoLight = 'InfoLight',
  SuccessLight = 'SuccessLight',
  WarningLight = 'WarningLight',
  ErrorLight = 'DangerLight',
  Light = 'Light',
  Dark = 'Dark',
}

/** Bootstrap class names for text alignment */
export enum TextAlignment {
  center = 'text-center',
  left = 'text-start',
  right = 'text-end',
}

@Component({
  selector: 'omgui-banner',
  templateUrl: './omgui-banner.component.html',
})
export class OmguiBannerComponent {
  /** Choose the type of banner rendered. ErrorLight is remapped to bootstrap danger-light */
  @Input() set type(type: BannerType) {
    if (type === BannerType.ErrorLight) {
      this.bannerType = 'danger-light';
    } else {
      this.bannerType = kebabCase(type);
    }
  }

  /** Whether or not the banner is dismissible. Defaults to false */
  @Input() dismissible = false;

  /** Whether or not to include the margin below the banner. Defaults to false */
  @Input() excludeBottomMargin = false;

  /** Sets the text alignment to left, right, or center. Defaults to center */
  @Input() set textAlignment(alignment: TextAlignment) {
    if (Object.values(TextAlignment).includes(alignment)) {
      this.alignment = alignment;
    }
  }

  /** Emits whenever the banner has been dismissed. Will never emit if the banner is not dismissible */
  @Output() dismissed = new EventEmitter<void>();

  /** @ignore */
  bannerType: string;

  /** @ignore */
  alignment = TextAlignment.center;
}

@NgModule({
  declarations: [OmguiBannerComponent],
  imports: [NgbAlertModule, CommonModule],
  exports: [OmguiBannerComponent],
})
export class OmguiBannerModule {}
